<div class="col-12 sm:col-12 md:col-12 lg:col-8 px-0">
    <div class="card p-4 border-round-md h-full" *ngIf="patient">

        <div class="flex flex-row align-items-start gap-2">
            <p-avatar [image]="getAvatar()" styleClass="mr-2 patient-avatar" size="xlarge" shape="circle" [style]="{'width': '56px', 'height': '56px'}"></p-avatar>
        
            <div class="flex flex-row sm:flex-row justify-content-between align-items-center flex-1 gap-4 mt-1">
                <div class="flex flex-column align-items-start sm:align-items-start">
                    <div class="text-xl font-semibold">{{ patient.user.first_name + ' ' + patient.user.last_name }}</div>
                    <div class="flex justify-content-between flex-wrap">
                        <div class="flex align-items-center justify-content-center">
                            <span class="text-sm font-normal">{{ patient.birth | timeSince: 'months' }}</span>
                        </div>
                        <div class="flex align-items-center justify-content-center ml-4">
                            <span class="text-sm font-normal" *ngIf="patient.patientNumber">{{ 'Núm. ' + patient.patientNumber }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>